<template>
  <div v-if="showBanner" class="cookie-banner">
    <div class="cookie-header">
      <img class="cookie-icon" src="@/assets/icons/cookies.svg" alt="logo"/>
      <div class="cookie-header-text">Cookies</div>
    </div>
    <div class="cookie-body">
      <p class="personal-data-text">К сайту подключен Сервис Яндекс.Метрика, который использует «cookies». Продолжая использовать наш сайт, вы соглашаетесь с условиями обработки cookie-файлов и пользовательских данных с помощью Яндекс.Метрика, необходимых для аналитики и улучшения качества работы сайта и сервиса. Вы можете запретить обработку сookies в настройках браузера</p>
    </div>
    <div class="cookie-footer">
      <a class="personal-data-link" href="https://www.primgidromet.ru/media/2026/06/politika-obrabotki-personalnyh-dannyh-2.1.pdf" target="_blank">Политика обработки персональных данных</a>
      <button class="accept_btn" @click="acceptCookies">Принять</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const showBanner = ref(false)

const COOKIE_KEY = 'cookiesAccepted'
const COOKIE_VERSION = 1

const acceptCookies = () => {
  localStorage.setItem(
      COOKIE_KEY,
      JSON.stringify({
        accepted: true,
        version: COOKIE_VERSION,
        date: new Date().toISOString(),
      })
  )

  showBanner.value = false
}

  onMounted(() => {
    const savedConsent = localStorage.getItem(COOKIE_KEY)
    if (!savedConsent) {
      showBanner.value = true
      return
    }
    try {
      const consent = JSON.parse(savedConsent)
      if (
          !consent.accepted ||
          consent.version !== COOKIE_VERSION
      ) {
        showBanner.value = true
      }
    } catch {
      // если старое значение было "true"
      showBanner.value = true
    }
})
</script>

<style>
.cookie-banner {
  position: fixed;
  bottom: 10px;
  left: 10px;
  background:
      linear-gradient(
          180deg,
          rgba(80, 117, 153, 1),
          rgba(50, 97, 123, 1)
      );
  color: white;
  border-radius: 20px;
  width: 480px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 16px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  text-align: center;
  justify-content: center;

  z-index: 10000;
}

.cookie-header {
  display: flex;
  align-items: center;
  gap: 20px;
}

.cookie-icon {
  width: 40px;
}

.cookie-header-text {
  font-size: 35px;
}

.cookie-body {
  text-align: justify;
}

.personal-data-text {
  margin: 0;
  line-height: 1.5;
  font-size: 16px;
}

.cookie-footer {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

.cookie-banner button {
    padding: 12px;
    background: #fff;
    border-radius: 10px;
    color: #000;
    text-align: center;
    width: 100%;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;

    transition:
        background-color .15s ease,
        transform .08s ease,
        box-shadow .15s ease;

    box-shadow: 0 2px 4px rgba(0,0,0,.15);

    border: none;
    outline: none;
    font: inherit;

    &:hover {
      background: #f5f5f5;
    }

    &:active {
      transform: scale(0.99);
      box-shadow: inset 0 2px 4px rgba(0,0,0,.2);
    }
}

.personal-data-link {
  color: #fff;
  margin: 0;
  padding: 0;
  opacity: 0.7;
}

.personal-data-link:hover {
  opacity: 1;
  cursor: pointer;
}

@media (max-width: 600px) {
  .cookie-banner {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding: 20px;
    font-size: 14px;
    gap: 15px;
    border-radius: 0;
  }

  .cookie-header {
    gap: 15px;
  }

  .cookie-icon {
    width: 30px;
  }

  .cookie-header-text {
    font-size: 25px;
  }

  .personal-data-text {
    line-height: 1.5;
    font-size: 14px;
  }

  .cookie-footer {
    gap: 15px;
    align-items: center;
  }

  .cookie-banner button {
    padding: 10px;
  }

}
</style>